import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// import required modules
import { FreeMode, Scrollbar, Mousewheel } from "swiper";

export default function ScrollContainer(props) {
    return (
        <>
            <Swiper
                direction={"vertical"}
                slidesPerView={"auto"}
                freeMode={true}
                scrollbar={true}
                mousewheel={true}
                modules={[FreeMode, Scrollbar, Mousewheel]}
                className="mySwiperScrollContainer"
            >
                <SwiperSlide className={"text-white"}>

                    { props.children }

                </SwiperSlide>
            </Swiper>
        </>
    );
}
